export default __webpack_public_path__ + "static/media/fortmatic.bf78280d.svg";